module.exports = __webpack_public_path__ + "img/watage_res_0.d9d78bac.gif";